import styled from 'styled-components';

export const ThankOuterWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
  `
);

export const ThankInnerWrap = styled.div(
  props => `
    width: 100%;
    max-width:1200px;
    margin:0 auto;
    display: flex;
    padding: 15px 0 70px;  
  `
);

export const ThankLeftOuterWrap = styled.div(
  props => `
    flex: 2;
    display: flex;
    flex-direction: column;  
  `
);
